/**
 * Environment configuration — single source of truth for all env vars.
 *
 * All VITE_ prefixed vars are available client-side via import.meta.env.
 * OAuth URIs point to the v2 Hono server which handles the OAuth flow
 * and redirects back with ?email=&otpId=&otp= for Dexie Cloud auto-login.
 */

// ---------------------------------------------------------------------------
// Dexie Cloud
// ---------------------------------------------------------------------------

export const DEXIE_CLOUD_URL =
  import.meta.env.VITE_DEXIE_CLOUD_URL || "https://zfbftppyv.dexie.cloud"

export const DEXIE_CLOUD_CLIENT_ID =
  import.meta.env.VITE_DEXIE_CLOUD_CLIENT_ID || ""

// ---------------------------------------------------------------------------
// API
// ---------------------------------------------------------------------------

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? "/api"

// ---------------------------------------------------------------------------
// OAuth Provider URIs — server-side callbacks that bridge to Dexie Cloud OTP
// ---------------------------------------------------------------------------

/** Server endpoint that initiates Google OAuth flow */
export const GOOGLE_AUTH_URI =
  import.meta.env.VITE_GOOGLE_AUTH_URI || `${API_BASE_URL}/auth/google`

/** Server endpoint that initiates GitHub OAuth flow */
export const GITHUB_AUTH_URI =
  import.meta.env.VITE_GITHUB_AUTH_URI || `${API_BASE_URL}/auth/github`

/** Server endpoint that initiates Apple OAuth flow */
export const APPLE_AUTH_URI =
  import.meta.env.VITE_APPLE_AUTH_URI || `${API_BASE_URL}/auth/apple`

/** Server endpoint that initiates Microsoft OAuth flow */
export const MICROSOFT_AUTH_URI =
  import.meta.env.VITE_MICROSOFT_AUTH_URI || `${API_BASE_URL}/auth/microsoft`

// ---------------------------------------------------------------------------
// Observability (P2)
// ---------------------------------------------------------------------------

export const APPLICATION_INSIGHTS_CONNECTION_STRING =
  import.meta.env.VITE_APPLICATION_INSIGHTS_CONNECTION_STRING || ""

/** Sampling percentage for App Insights telemetry (1-100). Default: 100. */
export const APPINSIGHTS_SAMPLING_PERCENTAGE = Number(
  import.meta.env.VITE_APPINSIGHTS_SAMPLING_PERCENTAGE || "100",
)

/** Project name for telemetry service name tagging. */
export const PROJECT_NAME = import.meta.env.VITE_PROJECT_NAME || "totodo-v2"

// ---------------------------------------------------------------------------
// RevenueCat — native in-app purchase SDK keys
// ---------------------------------------------------------------------------

export const REVENUECAT_IOS_API_KEY =
  import.meta.env.VITE_REVENUECAT_IOS_API_KEY || ""

export const REVENUECAT_ANDROID_API_KEY =
  import.meta.env.VITE_REVENUECAT_ANDROID_API_KEY || ""

// ---------------------------------------------------------------------------
// Database name derivation (matches v1 pattern)
// ---------------------------------------------------------------------------

const dbLink = DEXIE_CLOUD_URL.split("//")[1]?.split(".")[0] || ""
export const DEXIE_DB_NAME = `ToToDoDb-${dbLink}`

// ---------------------------------------------------------------------------
// Native debug logging
// ---------------------------------------------------------------------------

/** Enable native debug logging (NativeBridge → remote log-dump). Default: false. */
export const NOTIFICATION_LOGGING_ENABLED =
  import.meta.env.VITE_NOTIFICATION_LOGGING_ENABLED === "true"
